export class VcfUpdateCapabilityError extends Error {

    constructor(m?: string) {
        if(!m) {
            m = 'Cannot update user vehicle capability';
        }
        super(m);
    }
}
